import { ExportHistoryTranslations } from "./export-history-pt-br";

export const EXPORT_HISTORY_EN_US: ExportHistoryTranslations = {
	title: "Exported Spreadsheets",
	subtitle: "History of recent exports",
	noExports: "No exports found",
	noExportsDescription:
		"Your exported reports will be available here for 7 days to download or resend by email.",
	columns: {
		date: "Date/Time",
		user: "User",
		status: "Status",
		email: "Email",
		actions: "Actions",
		fileName: "File",
	},
	status: {
		success: "Success",
		pending: "Processing",
		error: "Error",
	},
	actions: {
		download: "Download",
		resend: "Resend",
		viewDetails: "View details",
		retry: "Try again",
	},
	tooltips: {
		processing:
			"We are processing your request.\nSoon, the report will be available for download",
		error: "Error processing your request.",
		download: "Download report",
		resend: "Resend report",
	},
	messages: {
		resendSuccess: "Spreadsheet resent successfully!",
		resendError: "Error resending spreadsheet",
		downloadError: "Error downloading spreadsheet",
		loading: "Loading...",
		loadError: "Error loading export history",
	},
	drawer: {
		title: "Exported Spreadsheets",
		description:
			"Here are the exports from the last 7 days. You can download or resend them to the registered email.",
		close: "Close",
	},
	exportButton: {
		export: "Export Spreadsheet",
		exportEmail: "Export for email",
		viewHistory: "Exported Spreadsheets",
	},
	reportTitle: "Report from {{startDate}} to {{endDate}}",
	exportedAt: "Exported {{date}} at {{time}}",
	to: "To:",
};
